import { render } from "./LimitsForm.vue?vue&type=template&id=d9c5985c"
import script from "./LimitsForm.vue?vue&type=script&lang=js"
export * from "./LimitsForm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__